export default "__VITE_ASSET__DRW$Mjx6__"